import React from 'react';

const ChevronDown = () => (
  <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6 9.16064L12 15.1606L18 9.16064" stroke="#2E2E7F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default ChevronDown;